module.exports = __webpack_public_path__ + "img/depmap_svg_V111.baa530d2.svg";